var map = {
	"./hays-logo.png": "9532",
	"./hp-logo.png": "e263",
	"./infraserv-logo.png": "c0a1",
	"./mbs-logo.png": "1750",
	"./strategy-gmbh-logo.png": "99c3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f992";